var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#f05540",
    "data-original": "#f05540",
    d: "M382.933 73.6H441.6V176h-58.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#f3705a",
    "data-original": "#f3705a",
    d: "M360.533 21.333H464V76.8H360.533z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M44.8 276.267V512h418.133V276.267L253.866 67.2C172.8 149.333 126.933 195.2 44.8 276.267z",
    fill: "#ffd15c",
    "data-original": "#ffd15c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M464 276.267 254.933 67.2c-41.6 40.533-73.6 72.533-105.6 104.533L44.8 276.266v48l209.067-209.067 209.067 209.067v6.4-54.4H464z",
    fill: "#f7b64c",
    "data-original": "#f7b64c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M216.533 512H90.667V388.267c0-35.2 28.8-62.933 62.933-62.933 35.2 0 62.933 28.8 62.933 62.933V512z",
    fill: "#415a6b",
    "data-original": "#415a6b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#344a5e",
    "data-original": "#344a5e",
    d: "M253.867 325.333h164.267v144H253.867z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#8ad7f8"
  }, /*#__PURE__*/React.createElement("path", {
    "data-original": "#8ad7f8",
    d: "M270.933 342.4h56.533v109.867h-56.533zM344.533 342.4h56.533v109.867h-56.533z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M502.4 232.533 279.467 9.6c-12.8-12.8-35.2-12.8-48 0L9.6 232.533c-12.8 12.8-12.8 35.2 0 48 12.8 12.8 35.2 12.8 48 0L256 82.133l198.4 198.4c12.8 12.8 35.2 12.8 48 0 12.8-13.866 12.8-35.2 0-48z",
    fill: "#f3705a",
    "data-original": "#f3705a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.967450915b3e6a415ee435a81a9498f4.svg";
export { ForwardRef as ReactComponent };